<template>
  <v-row>
    <v-col cols="8" class="py-0">
      <v-select
        label="Sort By"
        v-model="sortByField"
        :items="sortByFields"
        item-text="label"
        item-value="value"
        @change="onChange"
        dense
      ></v-select>
    </v-col>
    <v-col class="py-0">
      <v-select
        label="Direction"
        v-model="sortByDirection"
        :items="directions"
        item-text="label"
        item-value="value"
        @change="onChange"
        dense
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "sort-by",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      sortByFields: [
        { label: "Supplier", value: "supplierName" },
        { label: "Provider", value: "provider" },
        { label: "Price", value: "priceFrom" },
      ],
      directions: [
        { label: "Asc", value: "ASC" },
        { label: "Desc", value: "DESC" },
      ],
      sortByField: this.value ? this.value.fieldName : "",
      sortByDirection: this.value ? this.value.direction : "ASC",
    };
  },

  watch: {
    value(newVal) {
      (this.sortByField = newVal.fieldName ? newVal.fieldName : ""),
        (this.sortByDirection = newVal.direction ? newVal.direction : "ASC");
    },
  },

  methods: {
    onChange() {
      this.$emit("input", {
        fieldName: this.sortByField,
        direction: this.sortByDirection,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/rates-search/SortBy.vue